window.MoMA = window.MoMA || {};

window.MoMA.onImageError = async function(img, wait) {
  if (wait > 32) {
    img.onerror = null;
    return;
  }
  await new Promise(r => setTimeout(r, wait * 1000));
  var src = img.src;
  img.src = src;
  img.onerror = window.MoMA.onImageError(img, wait*2);
};
